<template>
	<label class="flex items-center" :class="{ 'pointer-events-none': disabled == true }">
		<input
			v-model="inputValue"
			type="checkbox"
			:disabled="disabled"
			class="switch appearance-none w-dj-60 h-dj-30 relative rounded-big bg-dj-gray-light opacity-50 transition-opacity cursor-pointer hover:opacity-100 after:transition-transform after:absolute after:top-[3px] after:left-[3px] after:w-dj-24 after:h-dj-24 after:bg-white after:rounded-full checked:after:translate-x-dj-30 checked:bg-dj-blue checked:opacity-100 checked:hover:bg-dj-blue-hover"
			:class="{
				'hover:opacity-50 checked:bg-dj-gray checked:hover:bg-dj-gray checked:hover:opacity-100':
					disabled == true,
			}"
		/>
		<span class="font-medium ml-dj-20"><slot></slot></span>
	</label>
</template>

<script lang="ts">
import { computed, defineComponent } from "vue";
export default defineComponent({
	name: "BaseSwitch",
	props: {
		modelValue: {
			type: Boolean,
			default: false,
		},
		disabled: {
			type: Boolean,
			default: false,
		},
	},
	emits: ["update:modelValue"],
	setup(props, { emit }) {
		const inputValue = computed<boolean>({
			get() {
				return props.modelValue;
			},
			set(value) {
				emit("update:modelValue", value);
			},
		});

		return {
			inputValue,
		};
	},
});
</script>
